/**
 * Stub of `@env` for the Vite web build (react-native-dotenv is native-only).
 * Solo accesos explícitos `import.meta.env.VITE_X`: usar `import.meta.env` entero mete TODAS las
 * variables VITE_* del .env en el bundle público (así se filtró la clave de Resend).
 */
function clean(value: string | undefined): string {
  return String(value || "").trim();
}

export const EXPO_PUBLIC_BACKEND_URL = clean(import.meta.env.VITE_BACKEND_URL) || "https://rycso.es/hermes";
export const EXPO_PUBLIC_BACKEND = EXPO_PUBLIC_BACKEND_URL;
export const EXPO_PUBLIC_BACKEND_FALLBACK_URL = clean(import.meta.env.VITE_BACKEND_FALLBACK_URL);
export const EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID = clean(import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID);
export const EXPO_PUBLIC_ENABLE_INTERNAL_ADMIN_MOBILE = "false";
/** El correo se envía siempre desde el servidor: la web nunca lleva la clave de Resend. */
export const EXPO_PUBLIC_RESEND_API_KEY = "";
export const EXPO_PUBLIC_RESEND_FROM_EMAIL = "Hermes <noreply@rycso.es>";
export const RESEND_API_KEY = "";
export const EXPO_PUBLIC_P2P_MAILER_URL = "";
